<div>
  <div id="printContent" #printContent>
    <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
      <img alt="tour button" src="/assets/images/tutorialOverlayBttn.svg" />
    </button>
    <div class="header-controls split-flex">
      <h3>
        <fa-icon [icon]="enrollIcon"/>
        Enroll
      </h3>
      <div class="print-hide filter-options align-items-end">
        <div class="purchase-logo-container message">
          @if (showCoTeacherFilter()) {
            <div class="print-hide show-coteacher-checkbox">
              <input id="coteacher-checkbox" class="form-check-input" type="checkbox" [(ngModel)]="hideSharedStudents">
              <label class="form-check-label" for="coteacher-checkbox">Hide Shared Students</label>
            </div>
          }
        </div>
        <div id="filters-wrapper" class="flex column-gap-20">
          @if (showTeacherFilter()) {
            <wf-school-admin-teacher-filter
              [allowAllOption]="true"
              (teacherChange)="onTeacherFilterChange()"
            ></wf-school-admin-teacher-filter>
          }
          <wf-students-filter [grades]="grades()" [classes]="classes()" [filterExtraSupport]="false" (filterChangeEvent)="filterStudents($event)"></wf-students-filter>
        </div>
        @if (!isReviewTeacher()) {
          <button id="export-button" class="btn export-report-button print-hide" (click)="exportStudentList()" [disabled]="isExporting()">
            <fa-icon [icon]="excelIcon" *ngIf="!isExporting()"></fa-icon>
            <fa-icon [icon]="loadingIcon" [spin]="true" *ngIf="isExporting()"></fa-icon>
            Export Student List
          </button>
          <button id="print-button" class="btn print-summary-button print-hide" (click)=printStudents()><fa-icon [icon]="printIcon"></fa-icon> Print Student List</button>
        }
      </div>
    </div>
    <div>
      <div class="report-section-header split-flex">
        <h5 class="results-report-header"><fa-icon [classes]="['print-hide']" [icon]="studentIcon"></fa-icon> Student List</h5>
      </div>
      <div class="boxed-content">
        <div class="diagnosticproduct-management-text-button-bar">
          @if (message()) {
            <div id="student-list-message" class="alert message" [class.alert-danger]="messageStatus() === 'error'" [class.alert-success]="messageStatus() === 'success'">
              <div class="icon">
                <fa-icon [icon]="messageStatus() === 'success' ? successIcon : errorIcon"></fa-icon>
              </div>
              <div>
                <div class="bold">{{ messageTitle() }}</div>
                {{ message() }}
              </div>
            </div>
          }
          <div class="print-hide diagnosticproduct-management-button-bar">
            @if (canManuallyEnroll()) {
              <button id="addButton" type="button" class="btn btn-success" (click)="addStudent()">
                <fa-icon [icon]="addStudentIcon"></fa-icon> Add
              </button>
            }
            @if (canPurchase()) {
              <button type="button" class="btn btn-success" (click)="showPurchaseDialog = true">
                <fa-icon [icon]="purchaseIcon"></fa-icon> Purchase
              </button>
            }
            @if (isCleverTeacher()) {
              <button id="addCleverSections" type="button" class="btn btn-clever" (click)="goToAddCleverSections()">
                <img src="/assets/images/clever.svg" width="20" height="20"/> Add Clever Sections
              </button>
            }
            @if (isClasslinkTeacher()) {
              <button id="addClasslinkSections" type="button" class="btn btn-clever" (click)="goToAddClassLinkSections()">
                <img src="/assets/images/classlink-logo.png" width="20" height="20"/> Add ClassLink Sections
              </button>
            }
            @if (!isParentUser() && !isReviewTeacher()) {
              <button id="deleteButton" type="button" class="btn btn-danger" [disabled]="!studentsSelected() || isDeleting()" (click)="archiveStudents()">
                <fa-icon [icon]="isDeleting() ? loadingIcon : deleteStudentIcon"></fa-icon>
                Delete
              </button>
            }
            @if (isParentUser()) {
              <button type="button" class="btn btn-danger" [disabled]="!studentsSelected()" (click)="showCancelDialog = true">
                <fa-icon [icon]="!isDeleting() ? cancelIcon : loadingIcon"></fa-icon>
                Cancel Subscription
              </button>
            }
            @if (canBulkEdit()) {
              <button
                id="bulk-edit-button"
                type="button"
                class="btn btn-success"
                [disabled]="selectedStudents().size < 2 || showBulkEdit() || isDeleting()"
                (click)="showBulkEditDialog()"
              >
                <fa-icon [icon]="editStudentIcon"></fa-icon> Bulk Edit
              </button>
            }
          </div>
        </div>
        <table class="report-table">
          <thead>
          <tr>
            <th class="print-hide">
              @if (canBulkEdit()) {
                <input type="checkbox"
                       (change)="bulkEditAllToggled($event)"
                       [checked]="displayedStudents().length > 0 && selectedStudents().size == displayedStudents().length"
                       [disabled]="displayedStudents().length == 0"
                />
              }
            </th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Grade</th>
            <th>Class</th>
            @if (showTeacherFilter()) {
              <th>Teacher</th>
            }
            <th>Username</th>
            <th>Password</th>
            <th>Session Time</th>
            <th>Extra Support</th>
            <th>Subscription</th>
          </tr>
          </thead>
          <tbody>
            @for (student of displayedStudents(); track student.userID) {
              <tr [class.co-teacher-access-student]="student.fromCoTeacherAccess">
                <td class="print-hide select-edit-cell">
                  @if (student.fromCoTeacherAccess) {
                    <fa-icon [icon]="coTeacherIcon"></fa-icon>
                  } @else {
                    <input type="checkbox" (change)="studentToggled($event)" [value]="student.userID" [checked]="selectedStudents().has(student.userID)">
                    <button type="button" class="btn btn-sm" title="Edit Student" (click)="editStudent(student.userID)">
                      <fa-icon [icon]="editStudentIcon"></fa-icon>
                    </button>
                  }
                </td>
                <td>{{ student.firstName }}</td>
                <td>{{ student.lastName }}</td>
                <td>{{ student.grade | displayGrade }}</td>
                <td>{{ student.schoolClass?.name || 'None' }}</td>
                @if (showTeacherFilter()) {
                  <td>{{ student.teacher || teacherNamesById()[student.teacherID] || 'Unknown' }}</td>
                }
                <td>{{ student.username }}</td>
                <td>{{ student.password }}</td>
                <td>{{ student.sessionLength }}</td>
                <td>{{ student.extraSupportNeeded ? 'Yes' : 'No' }}</td>
                <td>{{ student.assessmentType }}</td>
              </tr>
            } @empty {
              <tr><td colspan="10">No Students</td></tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<wf-student-bulk-edit
  [studentIds]="this.selectedStudents()"
  [teachers]="teachers()"
  [teacherClasses]="teacherClasses()"
  [sharedTeacherId]="sharedTeacherId()"
  [ssoUser]="this.managementUser()?.belongsToSSOSchool() ?? false"
  [isOpen]="showBulkEdit()"
  [isSaving]="isBulkEditSaving()"
  [saveError]="saveBulkEditError()"
  (onClose)="closeBulkEditDialog()"
  (onSave)="saveBulkEdit($event)">
</wf-student-bulk-edit>

@if (showPurchaseDialog) {
  <!-- Confirmation Dialog for purchasing new subscriptions -->
  <div class="assign-confirm-dialog-background"></div>
  <div class="modal-dialog" role="document" style="z-index: 1001;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="alert alert-success message">
            <div class="icon">
              <fa-icon [icon]="purchaseIcon"></fa-icon>
            </div>
            <div>
              <div class="bold">Purchase Subscription</div>
              Add additional subscriptions to your account
            </div>
          </div>
          <div>
            Additional students may be added by purchasing another subscription.
          </div>
          <div style="margin-top: 25px ;">
            Please contact <a href="mailto:customerservice@foundationsinlearning.com">Foundations in Learning</a> to discuss
            adding more subscriptions to your account.
          </div>
        </div>
        <div class="confirm-dialog-bottom-container modal-footer">
          <button class="btn" (click)="showPurchaseDialog = false">
            <fa-icon [icon]="returnIcon"></fa-icon> Back
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (showCancelDialog) {
  <!-- Confirmation Dialog for canceling subscriptions -->
  <div class="assign-confirm-dialog-background"></div>
  <div class="modal-dialog" role="document" style="z-index: 1001;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="alert alert-danger message">
            <div class="icon">
              <fa-icon [icon]="cancelIcon"></fa-icon>
            </div>
            <div>
              <div class="bold">Cancel Subscription</div>
              Be sure to print out the Diagnostic Report before cancelling your subscription if would like to retain a copy.
            </div>
          </div>
          <div>
            You are about to cancel subscriptions for the selected students. This will remove them from WordFlight, including
            any data and reports.
          </div>
          <div class="margin-top-10">
            <em>If you need to keep a copy of any reports, please print them before cancelling.</em>
          </div>
          <div class="margin-top-10">
            Would you like to go ahead and cancel your subscription?
          </div>
        </div>
        <div class="confirm-dialog-bottom-container modal-footer">
          <button class="btn btn-success" (click)="cancelStudentSubscriptions()">
            <fa-icon [icon]="successIcon"></fa-icon> Yes
          </button>
          <button class="btn" (click)="showCancelDialog = false">
            <fa-icon [icon]="returnIcon"></fa-icon> No
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (showSectionAddMessage) {
  <!-- Dialog after adding a clever section with students that already exist-->
  <div class="assign-confirm-dialog-background"></div>
  <div class="modal-dialog" style="z-index: 1001;" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" (click)="closeSectionAddNotification()">
          <div class="icon">
            <fa-icon [icon]="closeIcon"></fa-icon>
          </div>
        </button>
        @if (sectionAddMessage.studentList.length) {
          <div class="assign-confirm-text">
            The following students have existing WordFlight accounts and have been moved to your roster:
            <ul class="assign-confirm-student-list">
              @for (student of sectionAddMessage.studentList; track $index) {
                <li>{{ student }}</li>
              }
            </ul>
          </div>
        }
        @if (sectionAddMessage.blockedList.length) {
          <div class="assign-confirm-text">
            The following students have been marked by WordFlight to remain in their existing roster, please contact
            customer service if they need to be moved:
            <ul class="assign-confirm-student-list">
              @for (student of sectionAddMessage.blockedList; track $index) {
                <li>{{ student }}</li>
              }
            </ul>
          </div>
        }
      </div>
      <div class="confirm-dialog-bottom-container modal-footer">
        <button class="btn yes-dialog-btn" (click)="closeSectionAddNotification()">
          <fa-icon [icon]="successIcon"></fa-icon> Ok
        </button>
      </div>
    </div>
  </div>
}
